// extracted by mini-css-extract-plugin
export default {"root":"PersonalAccountSelect_root__lM29j","tab":"PersonalAccountSelect_tab__HB9rF","isSelected":"PersonalAccountSelect_isSelected__wg22d"};